import React from 'react'
import { FiLayers, FiUserPlus } from 'react-icons/fi'
import topTost from '../../utils/topTost';

const LeadsCreateHeader = () => {
  const handleClick = () => {
    topTost()
};

  return (
    <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
    
    </div>
  )
}

export default LeadsCreateHeader